/**
 * User Privileges Page - Microsoft 365 Style
 * Manage user access privileges
 */

import React from 'react';
import { makeStyles, Text } from '@fluentui/react-components';
import { ContentCard } from '../../../components/layout';

const useStyles = makeStyles({
  pageHeader: {
    marginBottom: '24px',
  },
  pageTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#323130',
  },
  filterSection: {
    marginBottom: '24px',
  },
  privilegesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '16px',
  },
  privilegeCard: {
    padding: '16px',
    border: '1px solid #e1dfdd',
    borderRadius: '8px',
    ':hover': {
      backgroundColor: '#f9f9f9',
    },
  },
});

export const UserPrivilegesFluentUI: React.FC = () => {
  const styles = useStyles();

  return (
    <div>
      <div className={styles.pageHeader}>
        <Text className={styles.pageTitle}>User Privileges</Text>
      </div>

      <ContentCard>
        <Text>User privileges management - Feature coming soon</Text>
      </ContentCard>
    </div>
  );
};

export default UserPrivilegesFluentUI;
